module.exports = __webpack_public_path__ + "img/sixpackcarrier22.29846578.jpg";